module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errPage-container"
  }, [_c('el-button', {
    staticClass: "pan-back-btn",
    attrs: {
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h2', [_vm._v("你没有权限去该页面")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.errGif,
      "width": "313",
      "height": "428",
      "alt": "Girl has dropped her ice cream."
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "随便看",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticClass: "pan-img",
    attrs: {
      "src": _vm.ewizardClap
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4da9f82e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/errorPage/401.vue
// module id = 331
// module chunks = 0